import { UITimerStore } from 'common/stores/UITimerStore';
import {
  AutoCloseTimer,
  CloseButtonTimer,
  ITimerStrategy,
  SkanTimer
} from './timer-strategies';
import { DisplayConfigType } from '../config';
import { MraidStore } from 'common/stores/MraidStore';

export class TimerStoreBuilder {
  private strategies: ITimerStrategy[];

  constructor(
    private mraidStore: MraidStore,
    private adContext: AdContext,
    private formatConfig: DisplayConfigType
  ) {
    this.strategies = [
      new SkanTimer(this.adContext, this.formatConfig),
      new AutoCloseTimer(this.formatConfig),
      new CloseButtonTimer(this.mraidStore, this.adContext, this.formatConfig)
    ];
  }

  run(timerStore: UITimerStore): void {
    this.strategies.filter(s => s.isRunnable()).forEach(s => s.run(timerStore));
  }
}
